import { Collapse as CollapseAntd, CollapseProps } from 'antd';
import classNames from 'classnames';
import { cloneElement, memo, ReactElement } from 'react';
import { icons } from 'utils/constants/icons';

const { Panel } = CollapseAntd;
const { CaretRightOutlined } = icons;

interface IProps extends CollapseProps {
  collapseIcon?: ReactElement;
}

const Collapse = memo(
  ({ className, collapseIcon = <CaretRightOutlined />, ...props }: IProps) => {
    const customClasses = classNames('bg-white', className);

    return (
      <CollapseAntd
        bordered={false}
        className={customClasses}
        expandIcon={({ isActive }) =>
          cloneElement(collapseIcon, {
            style: {
              fontSize: '18px',
              color: isActive ? '#0077cc' : '#003056',
            },
            rotate: isActive ? -90 : 0,
          })
        }
        {...props}
      />
    );
  },
);

export { Collapse, Panel };
